/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdAccountOverview } from './AdAccountOverview';
import {
    AdAccountOverviewFromJSON,
    AdAccountOverviewFromJSONTyped,
    AdAccountOverviewToJSON,
    AdAccountOverviewToJSONTyped,
} from './AdAccountOverview';

/**
 * 
 * @export
 * @interface ChannelOverview
 */
export interface ChannelOverview {
    /**
     * AdAccountOverview> $adAccounts
     * @type {Array<AdAccountOverview>}
     * @memberof ChannelOverview
     */
    adAccounts?: Array<AdAccountOverview>;
}

/**
 * Check if a given object implements the ChannelOverview interface.
 */
export function instanceOfChannelOverview(value: object): value is ChannelOverview {
    return true;
}

export function ChannelOverviewFromJSON(json: any): ChannelOverview {
    return ChannelOverviewFromJSONTyped(json, false);
}

export function ChannelOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChannelOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'adAccounts': json['adAccounts'] == null ? undefined : ((json['adAccounts'] as Array<any>).map(AdAccountOverviewFromJSON)),
    };
}

export function ChannelOverviewToJSON(json: any): ChannelOverview {
    return ChannelOverviewToJSONTyped(json, false);
}

export function ChannelOverviewToJSONTyped(value?: ChannelOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adAccounts': value['adAccounts'] == null ? undefined : ((value['adAccounts'] as Array<any>).map(AdAccountOverviewToJSON)),
    };
}

